// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2ff3S","insightsList":"newBusinessInsightsMenu_insightsList__3sH0b","active":"newBusinessInsightsMenu_active__1pIVq"};